<template>
  <div>
    <v-dialog
        v-model="dialog"
        persistent
        width="400"
        scrollable
    >

      <v-card>

        <v-card-title>
          Filtrer par
          <v-spacer/>
          <v-icon @click="close">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-4">

          <v-autocomplete
              :loading="isLoading"
              :disabled="isLoading"
              :items="recuperators"
              multiple
              item-value="id"
              item-text="name"
              v-model="recuperatorIds"
              label="Récupérateurs..."
              clearable
              chips small-chips deletable-chips
          ></v-autocomplete>

          <v-dialog
              ref="dialog"
              v-model="modal"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  @click:clear="dates = []"
                  v-model="dateRangeText"
                  readonly
                  append-icon="mdi-calendar-outline"
                  clearable
                  label="Dates de recouvrement..."
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>

            <v-date-picker v-model="dates" scrollable range>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">
                Fermer
              </v-btn>
              <v-btn text
                     color="primary"
                     :disabled="dates.length < 2"
                     @click="modal = false">
                ok
              </v-btn>
            </v-date-picker>
          </v-dialog>

          <v-select
              :items="statuses"
              item-value="value"
              item-text="name"
              v-model="status"
              label="Montant"
              clearable
          ></v-select>

        </v-card-text>


        <v-divider/>

        <v-card-actions>
          <v-btn color="primary"
                 @click="handleFilter"
                 :disabled="dates.length < 2 && !status && !recuperatorIds.length"
                 depressed block
                 type="submit">
            <v-icon left>mdi-magnify</v-icon>
            Rechercher
          </v-btn>
        </v-card-actions>

      </v-card>


    </v-dialog>

  </div>
</template>

<script>

import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      modal: false,
      dialog: false,
      isLoading: false,

      recuperators: [],

      dates: [],
      recuperatorIds: [],
      status: null,
    }
  },
  methods: {
    open() {
      this.dialog = true
      this.getRecuperators()
    },
    close() {
      this.dialog = false
    },
    handleFilter() {
      let data = {
        dates: this.dates,
        recuperatorIds: this.recuperatorIds,
        status: this.status,
      }
      this.$emit('filter', data)
      this.close()
    },
    getRecuperators() {
      this.isLoading = true
      HTTP.get('/v1/recoveries/recuperators').then(res => {
        this.isLoading = false
        this.recuperators = res.data.data
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  computed: {
    dateRangeText: {
      get() {
        return this.dates.join(' ~ ')
      },
      set(dates) {
        return dates
      }
    },
    statuses() {
      return [
        {name: 'Terminé', value: 'yes'},
        {name: 'Non terminé', value: 'no'}
      ]
    }
  },
}
</script>

